/**
 * @fileoverview GET handler for the "/deliverability/postmaster/:app_group_id/latest_event" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { deliverabilityPostmasterAppGroupIdLatestEvent } from "./constants";
import type { DeliverabilityPostmasterLatestEventResult } from "./types";
import { isDeliverabilityPostmasterLatestEventResult } from "./validators";

export const getDeliverabilityPostmasterLatestEvent = reactQueryFetcherAdapter(
  deliverabilityPostmasterAppGroupIdLatestEvent,
  (signal: AbortSignal, appGroupId: string): Promise<DeliverabilityPostmasterLatestEventResult> => {
    return fetch(`/deliverability/postmaster/${appGroupId}/latest_event`, "GET", {}, { signal });
  },
  isDeliverabilityPostmasterLatestEventResult
);
